import { GetDoc, GetDocs, StoreAccessor, WhereOp } from "mobx-firelink";
export const GetSeeds = StoreAccessor("GetSeeds", s => (bookID) => {
    return GetDocs({
        queryOps: [new WhereOp("book", "==", bookID)],
    }, a => a.seeds);
});
export const GetSeed = StoreAccessor("GetSeed", s => (id) => {
    if (id == null)
        return null;
    return GetDoc({}, a => a.seeds.get(id));
});
export const GetSelectedSeed = StoreAccessor("GetSelectedSeed", s => (bookID) => {
    if (bookID == null)
        return null;
    return GetSeed(s.main.write.selectedSeed);
});
